import { useEffect, useState } from "react";
import useClinicNotifications, {
  CSVCompletionNotificationType,
  ExcelCompletionNotificationType,
} from "hooks/use-clinic-notifications";
import { CSVReportResponse } from "services/types/reports.type";

interface CsvReportHookProps {
  currentFilters: Record<string, any> | undefined;
}

export const useCsvReportHook = ({ currentFilters }: CsvReportHookProps) => {
  const [csvReport, setCsvReport] = useState<CSVReportResponse | null>(null);
  const [csvReportIsReady, setCsvReportIsReady] = useState(false);

  const { systemMessages } = useClinicNotifications();
  useEffect(() => {
    let isReady = false;

    if (csvReport) {
      if ("csv_title" in csvReport) {
        const csvNotifications = systemMessages
          .filter(({ type }) => type === CSVCompletionNotificationType)
          .map(({ message }) => message);

        isReady =
          csvNotifications.some(
            ({ provider_id, csv_download_url, csv_title }) =>
              provider_id === csvReport.provider_id &&
              csv_download_url === csvReport.csv_download_url &&
              csv_title === csvReport.csv_title
          ) || false;
      } else {
        const excelNotifications = systemMessages
          .filter(({ type }) => type === ExcelCompletionNotificationType)
          .map(({ message }) => message);

        isReady =
          excelNotifications.some(
            ({ provider_id, xlsx_download_url, xlsx_title }) =>
              provider_id === csvReport.provider_id &&
              xlsx_download_url === csvReport.xlsx_download_url &&
              xlsx_title === csvReport.xlsx_title
          ) || false;
      }

      setCsvReportIsReady(isReady);
    }

    setCsvReportIsReady(isReady);
  }, [csvReport, systemMessages]);

  useEffect(() => {
    setCsvReportIsReady(false);
    setCsvReport(null);
  }, [currentFilters]);

  return { csvReport, csvReportIsReady, setCsvReport };
};
